import { z } from 'zod';

// A single measurement value: metric, nullable, and optional at the API boundary.
const measurementValue = z.number().nullable().optional();

// Circumferences are stored in centimeters.
export const bodyCircumferencesSchema = z.object({
    neck: measurementValue,
    shoulders: measurementValue,
    chest: measurementValue,
    waist: measurementValue,
    hip: measurementValue,
    arm: measurementValue,
    leg: measurementValue,
});
export type BodyCircumferences = z.infer<typeof bodyCircumferencesSchema>;

// Skinfolds are stored in millimeters (7-site Jackson-Pollock).
export const bodySkinfoldsSchema = z.object({
    chest: measurementValue,
    abdominal: measurementValue,
    thigh: measurementValue,
    triceps: measurementValue,
    subscapular: measurementValue,
    suprailiac: measurementValue,
    midaxillary: measurementValue,
});
export type BodySkinfolds = z.infer<typeof bodySkinfoldsSchema>;

export const bodyMeasurementsSchema = z.object({
    circumferences: bodyCircumferencesSchema.optional(),
    skinfolds: bodySkinfoldsSchema.optional(),
});
export type BodyMeasurements = z.infer<typeof bodyMeasurementsSchema>;

export const weightEntrySchema = z
    .object({
        id: z.string(),
        weightKg: z.number(),
        measuredAtUtc: z.string(),
        localDate: z.string(),
        source: z.string().nullable().optional(),
        notes: z.string().nullable().optional(),
        bodyFatPct: z.number().nullable().optional(),
        measurements: bodyMeasurementsSchema.nullable().optional(),
        createdAtUtc: z.string(),
        updatedAtUtc: z.string(),
    })
    ;
export type WeightEntry = z.infer<typeof weightEntrySchema>;

export const weightHistoryDocSchema = z.object({
    id: z.string(),
    userId: z.string(),
    weightKg: z.number(),
    measuredAtUtc: z.string(),
    localDate: z.string(),
    source: z.string().nullable(),
    notes: z.string().nullable(),
    bodyFatPct: z.number().nullable(),
    measurements: bodyMeasurementsSchema.nullable(),
    createdAtUtc: z.string(),
    updatedAtUtc: z.string(),
    deletedAt: z.string().nullable(),
});
export type WeightHistoryDocType = z.infer<typeof weightHistoryDocSchema>;
